export default __webpack_public_path__ + "static/media/ggcLogo2.21f9294d.png";